import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// take over scroll handling so in-page anchors (e.g. /#products) work
if ("scrollRestoration" in window.history) {
  window.history.scrollRestoration = "manual";
}

// Per-route document titles and all other head tags are managed in Seo.js.
function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // The target section may not exist until the new route has rendered,
      // so retry a few frames before giving up.
      let tries = 0;
      let id;
      const tryScroll = () => {
        const el = document.querySelector(hash);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
          return;
        }
        if (tries++ < 20) id = window.setTimeout(tryScroll, 40);
      };
      id = window.setTimeout(tryScroll, 0);
      return () => window.clearTimeout(id);
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}

export default ScrollToTop;
